import React, { useEffect, useState } from 'react';
import { MailIcon, PhoneIcon } from 'lucide-react';
export function Footer() {
  const [currentDateTime, setCurrentDateTime] = useState(new Date());
  useEffect(() => {
    // Update the time every minute
    const timer = setInterval(() => {
      setCurrentDateTime(new Date());
    }, 60000);
    return () => {
      clearInterval(timer);
    };
  }, []);
  const formatDate = (date: Date) => {
    return date.toLocaleString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    });
  };
  return <footer className="bg-white border-t border-gray-200 py-6 w-full" data-id="element-114">
      <div className="container mx-auto px-4" data-id="element-115">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-116">
          <div className="flex-shrink-0" data-id="element-117">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/wcGJehFU8moW1Bqmivv7jn/ethswitch_logo-1.png" alt="EthSwitch Logo" className="h-8" data-id="element-118" />
          </div>
          <div className="text-center md:text-right" data-id="element-119">
            <h3 className="text-lg font-semibold text-[#1A1F36] mb-2" data-id="element-120">
              Contact Us
            </h3>
            <div className="flex flex-col space-y-2" data-id="element-121">
              <a href="mailto:support@paysyslabs.com" className="flex items-center justify-center md:justify-end text-gray-600 hover:text-[#F58220]" data-id="element-122">
                <MailIcon size={16} className="mr-2" data-id="element-123" />
                support@paysyslabs.com
              </a>
              <a href="tel:+923132370605" className="flex items-center justify-center md:justify-end text-gray-600 hover:text-[#F58220]" data-id="element-124">
                <PhoneIcon size={16} className="mr-2" data-id="element-125" />
                +92-313-2370605
              </a>
            </div>
          </div>
        </div>
        <div className="mt-6 pt-4 border-t border-gray-200" data-id="element-126">
          <div className="flex flex-col md:flex-row justify-between items-center" data-id="element-127">
            <p className="text-sm text-gray-500 text-center md:text-left mb-2 md:mb-0 whitespace-nowrap" data-id="element-128">
              &copy; {new Date().getFullYear()} EthBridge Enterprise portal by
              PaySys Labs. All rights reserved.
            </p>
            <div className="text-sm text-gray-500 flex items-center whitespace-nowrap" data-id="element-129">
              <span className="mr-4" data-id="element-130">EthBridge Enterprise portal v2</span>
              <span data-id="element-131">{formatDate(currentDateTime)}</span>
            </div>
          </div>
        </div>
      </div>
    </footer>;
}